import React from 'react';
import useTheme from '@hero/branding/theme';
import Form, { useFormContext } from '@hero/ui-kit/inputs/Form';
import Radio from '@hero/ui-kit/inputs/Radio';
import RadioGroup from '@hero/ui-kit/inputs/RadioGroup';
import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import Section from '@hero/ui-kit/layout/Section';
import Button from '@hero/ui-kit/inputs/Button';
import mitigationOffersSchema from '../../../../../views/CancellationFlow/validator/mitigationOffersSchema';
import { useTransferToD2C } from '../context/TransferToD2CContext';
import InlineLoader from '../../../../../components/InlineLoader';

const FormElements: React.FC = () => {
    const { borders, colors } = useTheme();
    const {
        formState: { isValid }
    } = useFormContext();

    const radioStyle: React.CSSProperties = {
        padding: '1rem'
    };

    const border: React.CSSProperties = {
        ...borders.bottom,
        ...borders.variant.secondary,
        borderWidth: 2,
        borderColor: colors.neutrals.borderAlpha
    };

    return (
        <>
            <H role="h6">{`Let's encourage keeping Hero!`}</H>
            <P>Select the plan the member agrees to</P>
            <RadioGroup
                name="mitigation_offers"
                displayName=""
                noBorders
                styles={{ marginBottom: '0' }}
            >
                <Radio
                    id="regular-plans"
                    value="regular-plans"
                    labelText="Regular plans"
                    styles={{ ...radioStyle, ...border }}
                />
                <Radio
                    id="hardship-offers"
                    value="hardship-offers"
                    labelText="Hardship offers"
                    styles={{ ...radioStyle, ...border }}
                />
            </RadioGroup>
            <Section centered>
                <Button type="submit" width="large" disabled={!isValid}>
                    Next
                </Button>
            </Section>
        </>
    );
};

const MitigationOffers: React.FC = () => {
    const { handleChooseMitigationOffer, isLoadingPlans } = useTransferToD2C();

    if (isLoadingPlans) {
        return <InlineLoader />;
    }

    return (
        <Form validationSchema={mitigationOffersSchema} submitFn={handleChooseMitigationOffer}>
            <FormElements />
        </Form>
    );
};

export default MitigationOffers;
